import { ComponentAccess } from '../useCurrentAccessPolicy';

export const adminPolicy: ComponentAccess = {
  // LIMS
  canAccessLims: true,
  canCreateOrders: true,
  canEditOrders: true,
  canDeleteOrders: true,
  canManageSpecimens: true,
  canViewDiagnosticReports: true,
  canCreateDiagnosticReports: true,
  canReviewResults: true,
  canManageConsent: true,

  // Admin
  canAccessAdmin: true,
  canManageUsers: true,
  canManageAccessPolicies: true,
  canViewSystemStats: true,

  // Patient Management
  canAccessPatients: true,
  canCreatePatients: true,
  canEditPatients: true,
  canViewPatientHistory: true,
  canManageEncounters: true,
  canViewEncounters: true,

  // Tasks & Workflow
  canAccessTasks: true,
  canClaimTasks: true,
  canAssignTasks: true,
  canCompleteTasksForOthers: true,

  // Practitioner Management
  canAccessPractitioners: true,
  canViewPractitioners: true,
  canManagePractitioners: true,

  // Payment & Billing
  canAccessPayments: true,
  canManageChargeItems: true,
  canManageInvoices: true,
  canViewBillingAccounts: true,

  // Search
  canAccessSearch: true,

  // General
  canViewReports: true,
  canExportData: true,
  canManageDocuments: true,
};
